import "./review.scss";
import apiClient from "../common/apiClient";
import Review from "./Review";
import SecondaryButton from "../components/button/SecondaryButton";
import Button from "../components/button/Button";

class DesignLinerReviewBilateral extends Review {
  constructor(props) {
    super(props);

    this.creationTypeNewId = 531
    this.creationTypeDuplicateId = 532
    this.DuoId = 517
    this.TTid = 3
    this.kneeDisarticId = 6
    this.symesId = 4
    this.TFid = 5
    this.depth = 2

    this.state = {
      UOMs: [],
      socketTypes: [],
      notes: [],
      linerCreationType: [],
      baseLinerThickness: [],
      distalThickness: [],
      proximalThickness: [],
      posteriorThickness: [],
      medialThickness: [],
      highestCircumference: [],
      lengthToHighest: [],
      residualLength: [],
      totalLength: [],
      footDirection: [],
      partNumber: [],
      cadFileName: [],
      cadFile: [],
      duplicateLinerPartNumber: [],
      newLinerPartNumber: [],
      linerQuantityDuplicate: [],
      linerQuantityNew: [],
      fillInvagination: [],
      stovepipeLiner: [],

      cartData: [],
      designLinerSuspension: [],
      shapeCreation: [],
      designLinerFabric: [],
      designLinerType: [],
      linerColor: [],
      linerDesignOptions: [],
      linerDesignOption: [],
      designTechnicianContact: [],
      currentLiners: [],
    };
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadData();
  }

  async loadData() {
    try {
      await super.loadData();


      let config = { headers: {} };
      if (this.props.uniqueId != null) {
        config.headers.UniqueId = this.props.uniqueId;
      }

      let cartData = null
      const cartDataResponse = await Promise.all([
        apiClient.get("cart/" + this.props.formTypeId + '?formIndex=0',
          config
        ),
        apiClient.get("cart/" + this.props.formTypeId + '?formIndex=1',
          config
        )]
      );
      cartData = cartDataResponse[0].data.concat(cartDataResponse[1].data)

      let fieldInputConfig = {
        headers: {},
        params: {
          fieldNames: [
            "UOM",
            "footDirection",
            "amputationLevel",
            "shapeCreation",
            "notes",
            "designLinerSuspension",
            "designLinerType",
            "designLinerFabric",
            "linerColor",
            "baseLinerThickness",
            "distalThickness",
            "proximalThickness",
            "posteriorThickness",
            "medialThickness",
            "linerCreationType",
            "highestCircumference",
            "lengthToHighest",
            "residualLength",
            "totalLength",
            "linerDesignOption",
            "linerDesignOptions",
            "designTechnicianContact",
            "duplicateLinerPartNumber",
          ],
        },
      };

      if (this.props.uniqueId != null) {
        fieldInputConfig.headers.UniqueId = this.props.uniqueId;
        config.headers.UniqueId = this.props.uniqueId;
      }

      let fieldInputs = null
      const fieldInputsResponse =
        await Promise.all([apiClient.get("fieldInputs/" + this.props.formTypeId + '?formIndex=0',
          fieldInputConfig,
        ),
        apiClient.get("fieldInputs/" + this.props.formTypeId + '?formIndex=1',
          fieldInputConfig,
        )])
      fieldInputs = fieldInputsResponse[0].data.concat(fieldInputsResponse[1].data);

      let linerDesignOptions = (
        await apiClient.get("fieldOptions/" + this.props.formTypeId, {
          params: { fieldName: "linerDesignOption" },
        }
        )
      ).data;

      let cadFile = [];
      const cadFiles = (
        await Promise.all(
          [apiClient.get("cadFiles/" + this.props.formTypeId + '?formIndex=0',
            config),
          apiClient.get("cadFiles/" + this.props.formTypeId + '?formIndex=1',
            config)]
        ))
      cadFile.push(cadFiles[0].data)
      cadFile.push(cadFiles[1].data);

      this.setState({
        UOMs: fieldInputs.filter(
          (fi) => fi.fieldName === "UOM"
        ),
        socketTypes: fieldInputs.filter(
          (fi) => fi.fieldName === "amputationLevel"
        ),
        footDirection: fieldInputs.filter(
          (fi) => fi.fieldName === "footDirection"
        ),
        shapeCreation: fieldInputs.filter(
          (fi) => fi.fieldName === "shapeCreation"
        ),
        notes: fieldInputs.filter(
          (fi) => fi.fieldName === "notes"
        ),
        designLinerSuspension: fieldInputs.filter(
          (fi) => fi.fieldName === "designLinerSuspension"
        ),
        designLinerType: fieldInputs.filter(
          (fi) => fi.fieldName === "designLinerType"
        ),
        designLinerFabric: fieldInputs.filter(
          (fi) => fi.fieldName === "designLinerFabric"
        ),
        linerColor: fieldInputs.filter(
          (fi) => fi.fieldName === "linerColor"
        ),
        baseLinerThickness: fieldInputs.filter(
          (fi) => fi.fieldName === "baseLinerThickness"
        ),
        distalThickness: fieldInputs.filter(
          (fi) => fi.fieldName === "distalThickness"
        ),
        proximalThickness: fieldInputs.filter(
          (fi) => fi.fieldName === "proximalThickness"
        ),
        posteriorThickness: fieldInputs.filter(
          (fi) => fi.fieldName === "posteriorThickness"
        ),
        medialThickness: fieldInputs.filter(
          (fi) => fi.fieldName === "medialThickness"
        ),
        linerCreationType: fieldInputs.filter(
          (fi) => fi.fieldName === "linerCreationType"
        ),
        highestCircumference: fieldInputs.filter(
          (fi) => fi.fieldName === "highestCircumference"
        ),
        lengthToHighest: fieldInputs.filter(
          (fi) => fi.fieldName === "lengthToHighest"
        ),
        residualLength: fieldInputs.filter(
          (fi) => fi.fieldName === "residualLength"
        ),
        totalLength: fieldInputs.filter(
          (fi) => fi.fieldName === "totalLength"
        ),
        designTechnicianContact: fieldInputs.filter(
          (fi) => fi.fieldName === "designTechnicianContact"
        ),
        duplicateLinerPartNumber: fieldInputs.filter(
          (fi) => fi.fieldName === "duplicateLinerPartNumber"
        ),
        fillInvagination: fieldInputs.filter(
          (fi) => fi.fieldName === "linerDesignOption" && fi.fieldOptionName === "Fill Invagination"
        ),
        stovepipeLiner: fieldInputs.filter(
          (fi) => fi.fieldName === "linerDesignOption" && fi.fieldOptionName === "Stovepipe Liner"
        ),
        linerDesignOptions: linerDesignOptions,
        cadFile: cadFile,
      });

      config = {
        headers: {
          UniqueId: this.props.uniqueId,
        },
        params: {
          fieldNames: ["linerPromiseShipDates"],
        },
      };

      let linerPromiseShipDates = []
      const linerPromiseShipDatesResponse =
        await Promise.all([apiClient.get("fieldInputs/" + this.props.formTypeId + '?formIndex=0',
          config
        ),
        apiClient.get("fieldInputs/" + this.props.formTypeId + '?formIndex=1',
          config
        )
        ])
      linerPromiseShipDates = 
      linerPromiseShipDatesResponse[0].data != null && linerPromiseShipDatesResponse[1].data != null ?
      linerPromiseShipDatesResponse[0].data.concat(linerPromiseShipDatesResponse[1].data) : null

      if (linerPromiseShipDates === null) {
        let linerPartNumbers = []
        cartData.forEach(cd => {
          linerPartNumbers.push({ partNumber: cd.partNumber, formIndex: cd.formIndex + "", cutoffTime: 0, sourceId: "designLiner"})
        })
        
        let linerShipDateConfig = {
          params: {
            linerPartNumbers: JSON.stringify(linerPartNumbers),
          },
        };

        let shippingDates = (
          await apiClient.get("linerShipDate/",
            linerShipDateConfig,
          )
        ).data;

        cartData.map(cd => {
          cd.scheduledShipDate = this.formatShipDate(shippingDates.find((sd) => sd?.partNumber === cd.partNumber) ?? "");
          return cd;
        })
      } else {
        let parsedFieldOptions = linerPromiseShipDates.map(fi => {
          if (fi?.stringData !== null) {
            fi.stringData = JSON.parse(fi.stringData);
          }
          return fi;
        });
        cartData.map(cd => {
          const cartFieldInput = parsedFieldOptions.find((fi) => fi?.stringData?.fieldInputId === cd.fieldInputId);
          cd.scheduledShipDate = cartFieldInput?.stringData?.shipDate ?? "";
          return cd;
        })
      }
      this.setState({
        cartData: cartData
      });

      this.squashProductsToDisplay(this.state.cartData, this.state.linerCreationType[0].fieldOptionId)

    } catch (error) {
      console.log(error)
    }
    this.setState({ isLoaded: true });
  }

  async saveData() {

    for (let i = 0; i < this.depth; i++) {
      const cartData = this.state.cartData.filter(c => c.formIndex === i);
      let data = [];
      cartData.forEach((cartItem, index) => {
        data.push({
          fieldName: "LinerPromiseShipDates",
          dataIndex: index,
          stringData: JSON.stringify({ fieldInputId: cartItem.fieldInputId, shipDate: cartItem.scheduledShipDate, formIndex: i }),
        });
      });
      await apiClient.post("fieldInputs/" + this.props.formTypeId + '?formIndex=' + i,
        data
      );
    }

    return apiClient.post("orders/" + this.props.formTypeId + '?isBilateral=true', null);
  }

  cartTotal(cart) {
    let total = 0;
    cart.forEach((item) => {
      if (item.quantity > 0 && item.price > 0) {
        total += item.price * item.quantity;
      }
    });

    return total;
  }

  formatPrice(price) {
    return Number(price).toFixed(2);
  }

  
  generateProducts(currentLiners, state, formIndex, addDetailClass = true) {
    return (
      <>
        {currentLiners.map((item, index) => {
          if (item.partNumber !== "DES-SETUP") {
            return (
              <div key={index}  className={addDetailClass ? "detail" : ""}>
                <div className="detailContentWrapper">
                  <div className="content">
                    <p>
                      {item.name}
                    </p>
                  </div>
                  <div className="content">
                    <span>Part Number:</span>
                    <p>
                      {item.partNumber}
                    </p>
                  </div>
                  <div className="content">
                    <span>Quantity:</span>
                    <p>
                      {item.quantity}
                    </p>
                  </div>
                  <div className="content">
                    <span>Scheduled Ship Date:</span>
                    <p style={{ alignContent: "end" }}>
                      {item.scheduledShipDate}
                    </p>
                  </div>
                  {state.linerCreationType[formIndex]?.fieldOptionId === this.creationTypeDuplicateId ?
                    <div className="content">
                      <span>Serial Number:</span>
                      <p>{state.duplicateLinerPartNumber[formIndex].stringData}</p>
                    </div>
                    : <></>}
                </div>
              </div>
            )
          }
        })}
      </>
    )
  }

  squashProductsToDisplay(cartData, linerCreationType) {
    const liners = cartData;
    let linersToDisplay = []
    if (linerCreationType === this.creationTypeNewId) {
      const groupedLiners = Object.groupBy(liners, ({ formIndex }) => {
        return formIndex
      });
      const groupedList = Object.entries(groupedLiners).map(([key, values]) => ({
        key,
        values
      }));
      for (let i = 0; i < groupedList.length; i++) {
        groupedList[i].values.forEach(l => {
          let liner = l;
          let duplicateDesignLinerPartNumber = ""
          switch (l.partNumber) {
            case "ALL-DES-OT":
            case "ALL-DES-EO":
              duplicateDesignLinerPartNumber = "ALL-DES-DP";
              break;
            case "ALC-DES-OT":
            case "ALC-DES-EO":
              duplicateDesignLinerPartNumber = "ALC-DES-DP";
              break;
            case "ADC-DES-OT":
            case "ADC-DES-EO":
              duplicateDesignLinerPartNumber = "ADC-DES-DP";
              break;
            default:
              break;
          }
          if (duplicateDesignLinerPartNumber === "") {
            return;
          }
          const duplicateQuantity = groupedList[i].values.find(l => l.partNumber === duplicateDesignLinerPartNumber)?.quantity ?? 0;
          const impactedLiner = { ...liner }
          impactedLiner.quantity += duplicateQuantity;
          linersToDisplay.push(impactedLiner)
        })
      }
    } else {
      linersToDisplay = liners.filter(l => l.partNumber !== "DES-SETUP");
    }

    this.setState({ currentLiners: linersToDisplay });
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();
    return (
      <>
        <div className="reviewWrapper bilateralWrapper">
          <div className="reviews">
            <div>
              {!this.props.showOrderSummary && (
                <div className="summaryName">
                  <h4>Order Summary</h4>
                  <div className="bileralName">
                    <h2>{this.props.bilateralName}</h2>
                  </div>
                </div>
              )}
              <div className="summaaryHeader">
                <h2>
                  {this.props.formName}
                  {" - Bilateral"}
                </h2>
                <div className="poDate">
                  <div className="po">
                    <span>Patient ID:</span>
                    <p>{this.state.patientId}</p>
                  </div>
                  <div className="po">
                    <span>PO:</span>
                    <p>{this.state.poNumber}</p>
                  </div>
                  {this.state.soNumber &&
                      <div className="po">
                        <span>SO Number:</span>
                        <p>{this.state.soNumber}</p>
                      </div>
                    }
                </div>
              </div>
            </div>

            {this.state.linerCreationType[0].fieldOptionId === this.creationTypeNewId ?
              <>
                {this.props.formIndex.map((fi, index) => {
                  return (
                    <div key={index} className="information">
                      <div className="subDetail">
                        <h3>
                          {"Order " + (fi + 1) + " "}
                          (New Liner)
                        </h3>
                        <h3>{this.state.footDirection[fi].fieldOptionName}</h3>
                        <div className="detailWrapper">
                          <div>

                            <div className="detail">
                              <h4>Product</h4>
                              {this.generateProducts(this.state.currentLiners.filter(cd => cd.formIndex === index), this.state, null, false)}
                            </div>

                            <div className="detail">
                              <h4>Patient Information</h4>
                              <div className="detailContentWrapper">

                                <div className="content">
                                  <span>Shape Creation:</span>
                                  <p>{this.state.shapeCreation[fi].fieldOptionName}</p>
                                </div>
                                {this.state.cadFile[fi] !== null ? (
                                  <div className="content">
                                    <span>Filename:</span>
                                    <p>{this.state.cadFile[fi].cadFileName}</p>
                                  </div>
                                ) : <></>}

                                <div className="content">
                                  <span>Amputation Level:</span>
                                  <p>{this.state.socketTypes[fi].fieldOptionName}</p>
                                </div>

                              </div>
                            </div>

                            <div className="detail">
                              <h4>Measurements</h4>
                              <div className="detailContentWrapper">
                                <div className="">
                                  {this.state.highestCircumference[fi].stringData !== null && this.state.highestCircumference[fi].stringData !== "" ?
                                    <div className="content">
                                      <span>Highest Circumference:</span>
                                      <p>
                                        {" "}
                                        {this.imageMeasurementEntry(
                                          this.state.highestCircumference[fi].stringData,
                                          this.state.UOMs[fi].fieldOptionName
                                        )}
                                      </p>
                                    </div> :
                                    <div className="content">
                                      <span>Highest Circumference:</span>
                                      <p>
                                        {" "}
                                        No Value Entered
                                      </p>
                                    </div>}
                                  {this.state.residualLength[fi].stringData !== null && this.state.residualLength[fi].stringData !== "" ?
                                    <div className="content">
                                      <span>Residual Length:</span>
                                      <p>
                                        {this.imageMeasurementEntry(
                                          this.state.residualLength[fi].stringData,
                                          this.state.UOMs[fi].fieldOptionName
                                        )}
                                      </p>
                                    </div> :
                                    <div className="content">
                                      <span>Residual Length:</span>
                                      <p>
                                        {" "}
                                        No Value Entered
                                      </p>
                                    </div>}
                                  {this.state.socketTypes[fi].fieldOptionId === this.TTid || this.state.socketTypes[fi].fieldOptionId === this.symesId ?
                                    <>
                                      {this.state.totalLength[fi].stringData !== null && this.state.totalLength[fi].stringData !== "" ?
                                        <div className="content">
                                          <span>Total Length:</span>
                                          <p>
                                            {" "}
                                            {this.imageMeasurementEntry(
                                              this.state.totalLength[fi].stringData,
                                              this.state.UOMs[fi].fieldOptionName
                                            )}
                                          </p>
                                        </div> :
                                        <div className="content">
                                          <span>Total Length:</span>
                                          <p>
                                            {" "}
                                            No Value Entered
                                          </p>
                                        </div>}
                                    </> : <></>}
                                  {this.state.socketTypes[fi].fieldOptionId === this.TFid || this.state.socketTypes[fi].fieldOptionId === this.kneeDisarticId ?
                                    <>
                                      {this.state.lengthToHighest[fi].stringData !== null && this.state.lengthToHighest[fi].stringData !== "" ?
                                        <div className="content">
                                          <span>Length To Highest:</span>
                                          <p>
                                            {" "}
                                            {this.imageMeasurementEntry(
                                              this.state.lengthToHighest[fi].stringData,
                                              this.state.UOMs[fi].fieldOptionName
                                            )}
                                          </p>
                                        </div> :
                                        <div className="content">
                                          <span>Length To Highest:</span>
                                          <p>
                                            {" "}
                                            No Value Entered
                                          </p>
                                        </div>}
                                    </> : <></>}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div>
                            <div className="detail">
                              <h4>Product Information</h4>
                              <div className="detailContentWrapper">
                                <div className="content">
                                  <span>Liner Type:</span>
                                  <p>{this.state.designLinerSuspension[fi].fieldOptionName}</p>
                                </div>
                                {this.state.designLinerSuspension[fi].fieldOptionId !== this.DuoId ?
                                  <>
                                    <div className="content">
                                      <span>Interface Material:</span>
                                      <p>{this.state.designLinerType[fi].fieldOptionName}</p>
                                    </div>

                                    <div className="content">
                                      <span>Fabric:</span>
                                      <p>{this.state.designLinerFabric[fi].fieldOptionName}</p>
                                    </div>
                                    <div className="content">
                                      <span>Fabric Color:</span>
                                      <p>{this.state.linerColor[fi].fieldOptionName}</p>
                                    </div>
                                  </> : <></>}
                              </div>
                            </div>

                            <div className="detail">
                              <h4>Requested Starting Thickness</h4>
                              <div className="detailContentWrapper">
                                <div className="">
                                  {this.state.baseLinerThickness[fi].numericData !== null && this.state.baseLinerThickness[fi].numericData !== "" ?
                                    <div className="content">
                                      <span>Base Liner Thickness:</span>
                                      <p>
                                        {" "}
                                        {this.imageMeasurementEntry(
                                          this.state.baseLinerThickness[fi].numericData,
                                          "mm"
                                        )}
                                      </p>
                                    </div> :
                                    <div className="content">
                                      <span>Base Liner Thickness:</span>
                                      <p>
                                        {" "}
                                        No Value Entered
                                      </p>
                                    </div>}
                                  {this.state.distalThickness[fi].numericData !== null && this.state.distalThickness[fi].numericData !== "" ?
                                    <div className="content">
                                      <span>Distal Thickness:</span>
                                      <p>
                                        {" "}
                                        {this.imageMeasurementEntry(
                                          this.state.distalThickness[fi].numericData,
                                          "mm"
                                        )}
                                      </p>
                                    </div> :
                                    <div className="content">
                                      <span>Distal Thickness:</span>
                                      <p>
                                        {" "}
                                        No Value Entered
                                      </p>
                                    </div>}
                                  {this.state.proximalThickness[fi].numericData !== null && this.state.proximalThickness[fi].numericData !== "" ?
                                    <div className="content">
                                      <span>Proximal Thickness:</span>
                                      <p>
                                        {this.imageMeasurementEntry(
                                          this.state.proximalThickness[fi].numericData,
                                          "mm"
                                        )}
                                      </p>
                                    </div> :
                                    <div className="content">
                                      <span>Proximal Thickness:</span>
                                      <p>
                                        {" "}
                                        No Value Entered
                                      </p>
                                    </div>}

                                  {this.state.socketTypes[fi].fieldOptionId === this.TTid || this.state.socketTypes[fi].fieldOptionId === this.symesId ?
                                    <>
                                      {this.state.posteriorThickness[fi].numericData !== null && this.state.posteriorThickness[fi].numericData !== "" ?
                                        <div className="content">
                                          <span>Posterior Thickness:</span>
                                          <p>
                                            {" "}
                                            {this.imageMeasurementEntry(
                                              this.state.posteriorThickness[fi].numericData,
                                              "mm"
                                            )}
                                          </p>
                                        </div> :
                                        <div className="content">
                                          <span>Posterior Thickness:</span>
                                          <p>
                                            {" "}
                                            No Value Entered
                                          </p>
                                        </div>}
                                    </> : <></>}
                                  {this.state.socketTypes[fi].fieldOptionId === this.TFid || this.state.socketTypes[fi].fieldOptionId === this.kneeDisarticId ?
                                    <>
                                      {this.state.medialThickness[fi].numericData !== null && this.state.medialThickness[fi].numericData !== "" ?
                                        <div className="content">
                                          <span>Medial Thickness:</span>
                                          <p>
                                            {" "}
                                            {this.imageMeasurementEntry(
                                              this.state.medialThickness[fi].numericData,
                                              "mm"
                                            )}
                                          </p>
                                        </div> :
                                        <div className="content">
                                          <span>Medial Thickness:</span>
                                          <p>
                                            {" "}
                                            No Value Entered
                                          </p>
                                        </div>}
                                    </> : <></>}

                                  <div className="content">
                                    {
                                      this.makeConditionalFieldOutput(
                                        "Fill Invagination",
                                        this.state.fillInvagination.filter(fiv => fiv.formIndex == fi),
                                        "booleanData",
                                      )
                                    }
                                  </div>

                                  <div className="content">
                                    {
                                      this.makeConditionalFieldOutput(
                                        "Stovepipe Liner",
                                        this.state.stovepipeLiner.filter(fiv => fiv.formIndex == fi),
                                        "booleanData",
                                      )
                                    }
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="msgInfo ">
                        <h3>Would you like a Design Technician to contact you?</h3>
                        <p>{this.state.designTechnicianContact[fi].fieldOptionName}</p>
                      </div>


                      <div className="msgInfo ">
                        <h3>Other Notes</h3>
                        <p>{this.state?.notes ? (this.state.notes[fi].stringData === null ? "None Entered" : this.state.notes[fi].stringData) : "None Entered"}</p>
                      </div>
                    </div>
                  )
                })}
              </>
              : <div className="information d-flex" style={{ gap: "32px" }}>
                {this.props.formIndex.map((fi, index) => {
                  return (
                    <div key={index} className="detail me-2">
                      <h3>
                        {"Order " + (fi + 1) + " "}
                        (Duplicate Liner)
                      </h3>
                      <h3>{this.state.footDirection[fi].fieldOptionName}</h3>
                      <div className="detailWrapper flex-wrap">
                        {this.generateProducts(this.state.currentLiners.filter(cd => cd.formIndex === fi), this.state, fi)}
                      </div>
                      <div className="msgInfo detail">
                        <h3>Other Notes</h3>
                        <p>{this.state?.notes ? (this.state.notes[fi].stringData === null ? "None Entered" : this.state.notes[fi].stringData) : "None Entered"}</p>
                      </div>
                    </div>
                  )
                })}
              </div>}

            <div className="information">
              <h3>Customer Information</h3>
              <div className="patientInfo">
                <div className="customerInfo">
                  <div className="patientSubInfo">
                    <span>Bill to account:</span>
                    <p>{this.state.accountNumber}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Clinic:</span>
                    <p>{this.state.clinicName}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Clinician Name:</span>
                    <p>{this.state.prosthetistName}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Email Address</span>
                    <p>{this.state.email}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Phone</span>
                    <p>{this.state.phone}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="information">
              <h3>Shipping Information</h3>
              <div className="patientInfo">
                <div className="">
                  <div className="borderBotom">
                    <div className="patientSubInfo">
                      <span>Shipping Address:</span>
                      <p>{this.state.shippingAddress1}</p>
                      <p>{this.state.shippingAddress2}</p>
                      <p>{this.state.city}, {this.state.stateName}</p>
                      <p>{this.state.zip}</p>
                    </div>
                  </div>

                  <div className="shipping info">
                    <div className="patientSubInfo">
                      <span>Shipping Method:</span>
                      <p>{this.state.shippingMethodName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Carrier:</span>
                      <p>{this.state.shippingCarrierName}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {this.state.cartData.length > 0 ? (
              <div className="information">
                <div className="mb-3"><h3>Cart</h3></div>
                <div className="patientInfo">
                  <div className="cartSubInfo">
                    <table className="transparent-table table">
                      <thead>
                        <tr>
                          <th><span><b>Name</b></span></th>
                          <th></th>
                          <th><span><b>Part Number</b></span></th>
                          <th><span><b>Quantity</b></span></th>
                          <th className="text-right"><span><b>Price</b></span></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.cartData.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td lg="6" sm="1">
                                <div className="content">
                                  <p className="break-spaces">{item.name.trim()}</p>
                                  {!item.partNumber.includes("DES-SETUP") ?
                                    <>
                                      {item.serialNumber ? <p>Serial Number: {item.serialNumber}</p> : <></>}
                                      {item.footSide ? <p>Side: {item.footSide}</p> : <></>}
                                    </> : <></>}
                                </div>
                              </td>
                              <td></td>
                              <td>
                                <p>{item.partNumber}</p>
                              </td>
                              <td>
                                <p>{item.quantity}</p>
                              </td>
                              <td>
                                <p className="text-right">${this.formatPrice(item.price)}</p>
                              </td>
                            </tr>
                          )
                        })}
                        <tr>
                          <td>
                            <div>
                              <span><b>Total</b></span>
                            </div>
                          </td>
                          <td colSpan={4}>
                            <p className="text-right">
                              ${this.formatPrice(this.cartTotal(this.state.cartData))}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : <></>}

          </div >
        </div >

        {this.getNavButtons(this.props.uniqueId)}
      </>
    );
  }

  getNavButtons(uniqueId) {
    if (uniqueId != null) {
      return;
    }

    return (
      <div className="handelButtons">
        <div className="stepBtn">
          <SecondaryButton
            text="Back"
            onClick={() =>
              this.props.handleBack(this?.props?.currentIndex - 1)
            }
            disabled={
              this.props.activeOuterStep == 0 && this.props.innerStep == 0
            }
          />
          <Button
            text="Submit"
            disabled={this.state.isLoading}
            onClick={() => {
              this.saveData();
              this.props.handleNext(this.props.currentIndex, this.props.orderIndex);
            }}
          />
        </div>
      </div>
    );
  }
}

export default DesignLinerReviewBilateral;